'use client'

import { useEffect } from 'react'
import {
  trackGlossarioTermoAberto,
  trackAtividadeMeiAberta,
  trackTemplateAberto,
  type TemplateSlug,
} from '@/lib/analytics'

/**
 * Componentes invisiveis que disparam um evento de view ao montar.
 * Versao de view-tracking equivalente ao blog-tracking.tsx, para paginas
 * de detalhe de glossario/atividade/template.
 */

export function GlossarioViewTracker({ termo }: { termo: string }) {
  useEffect(() => {
    trackGlossarioTermoAberto(termo)
  }, [termo])
  return null
}

export function AtividadeMeiViewTracker({ atividade }: { atividade: string }) {
  useEffect(() => {
    trackAtividadeMeiAberta(atividade)
  }, [atividade])
  return null
}

export function TemplateViewTracker({ template }: { template: TemplateSlug }) {
  useEffect(() => {
    trackTemplateAberto(template)
  }, [template])
  return null
}
